import NarrowInputField from "../../components/input/new/narrowInputField";
import RadioButton from "../../components/input/new/radioButton";
import React, { useState } from "react";
import { FcGoogle } from "react-icons/fc";
import { FaApple } from "react-icons/fa";
import "./clientSignupWithAppointment.css";
import ClientOnboardingHeader from "../../components/clientToolbar/clientOnboardingHeader";
import Footer from "../../components/footer";
import BackIcon from "../assets/backIcon.png";
import { useNavigate, useLocation } from "react-router-dom";
import ClientLoginPopup from "../../home/new/components/clientLoginPopup";
import { getPracticeAreaLabel } from "../../helpers/stringHelper";
import NarrowPasswordField from "../../components/input/new/narrowPasswordField";
import { supabase } from "../../supabaseClient";

const ClientSignupWithAppointment = () => {
  const navigate = useNavigate();
  const location = useLocation(); // Get the location (URL)

  const [email, setEmail] = useState("");
  const [gender, setGender] = useState("");
  const [dob, setDob] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  const queryParams = new URLSearchParams(location.search);
  const lawyerId = queryParams.get("lawyerId");
  const lawyerName = queryParams.get("lawyerName");
  const priceId = queryParams.get("priceId");
  const productId = queryParams.get("productId");
  const accountId = queryParams.get("accountId");
  const date = queryParams.get("date");
  const startTime = queryParams.get("startTime");
  const endTime = queryParams.get("endTime");
  const price = queryParams.get("price");
  const practiceAreas = queryParams.get("practiceAreas");
  const firmId = queryParams.get("firmId");
  const appointmentTypeId = queryParams.get("appointmentTypeId");
  const appointmentName = queryParams.get("appointmentName");
  const lawyerPhoto = queryParams.get("lawyerPhoto");
  const practiceAreasArray = practiceAreas ? practiceAreas.split(",") : [];
  const practiceAreaLabels = practiceAreasArray.map((key) => {
    const label = getPracticeAreaLabel(key);
    return label || key;
  });
  const practiceAreasDisplay = practiceAreaLabels.join(", ");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const openLoginPopup = () => setShowLoginPopup(true);

  // Close Login Popup function
  const closeLoginPopup = () => setShowLoginPopup(false);
  const passwordsMatch = password === confirmPassword;

  const handleContinue = async () => {
    if (password.length < 8 || !passwordsMatch) return;
    try {
      const { user, error } = await supabase.auth.signUp({
        email,
        password,
        options: {
          emailRedirectTo: "https://www.quidpro.ai/complete-signup/",
          data: {
            role: "client",
            pendingAppointment: {
              lawyerId,
              lawyerName,
              lawyerPhoto,
              accountId,
              appointmentName,
              practiceAreas,
              price,
              date,
              startTime,
              endTime,
              priceId,
              productId,
              firmId,
              appointmentTypeId,
            },
          },
        },
      });
      if (error) {
        console.error("Error signing up:", error.message);
        alert("Failed to send verification email.");
      } else {
        console.log("No error—about to navigate");
        navigate("/createuser/confirm-email");
      }
    } catch (err) {
      console.error("Unexpected error:", err);
      alert("Something went wrong. Please try again later.");
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div className="client-signup-page-container">
        <ClientOnboardingHeader openLoginPopup={openLoginPopup} />
        <div>
          <div className="appointment-header-div">
            <img
              src={BackIcon}
              onClick={() => {
                navigate(-1);
              }}
              style={{ width: "24px", height: "24px" }}
              alt="back icon"
            />

            <div className="lawyer-details-box-signup">
              <h1 className="lawyer-detail-signup-service-type">
                {appointmentName}
              </h1>
              <div className="lawyer-detail-signup-box-inner">
                <div>
                  {lawyerPhoto ? (
                    <img
                      src={lawyerPhoto}
                      alt={`${lawyerName}'s profile`}
                      style={{
                        height: "76px",
                        width: "76px",
                        borderRadius: "50%",
                      }}
                      loading="lazy"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/default-avatar.png"; // Path to a default avatar image
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        height: "76px",
                        width: "76px",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "30px",
                        color: "white",
                      }}
                    >
                      {lawyerName.charAt(0).toUpperCase()}
                    </div>
                  )}
                </div>

                <div className="lawyer-detail-signup-contents">
                  <div
                    style={{
                      gap: "12px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <h1 className="lawyer-detail-signup-name">{lawyerName}</h1>
                    <h3 className="lawyer-detail-signup-practice-areas">
                      {practiceAreasDisplay}
                    </h3>
                    <h3 className="lawyer-detail-signup-time">
                      {date} at {startTime}
                    </h3>
                  </div>
                  <p className="lawyer-detail-signup-time">
                    Total amount:{" "}
                    <span className="lawyer-detail-signup-price">${price}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* <NarrowInputField
            name="Email Address"
            title="Email address"
            placeholder="Enter your email"
            isRequired={true}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            halfWidth={false}
          />
          <div className="client-name-row">
            <NarrowInputField
              name="First N"
              title="Legal first name"
              placeholder="Enter your first name"
              isRequired={true}
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              halfWidth={true}
            />
            <NarrowInputField
              name="Email Address"
              title="Legal last name"
              placeholder="Enter your last name"
              isRequired={true}
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              halfWidth={true}
            />
          </div>

          <NarrowInputField
            name="Date of birth"
            title="Date of birth"
            placeholder="mm/dd/yyyy"
            isRequired={true}
            value={dob}
            onChange={(e) => setDob(e.target.value)}
            halfWidth={false}
          />

          <div className="radio-row">
            <p className="row-title"> Gender </p>

            <RadioButton
              label="Female"
              name="gender"
              value="female"
              checked={gender === "female"}
              onChange={(e) => setGender(e.target.value)}
            />
            <RadioButton
              label="Male"
              name="gender"
              value="male"
              checked={gender === "male"}
              onChange={(e) => setGender(e.target.value)}
            />
          </div>

          <div style={{ height: "1rem" }} />

          <button className="client-signup-continue-button">Continue</button>

          <div className="divider">
            <span>or</span>
          </div>

          <div className="signup-social-login-buttons">
            <button className="signup-google-btn">
              <FcGoogle style={{ paddingBottom: "1px" }} />
              Continue with Google
            </button>
            <button className="signup-apple-btn">
              <FaApple style={{ paddingBottom: "3px" }} />
              Continue with Apple
            </button>
          </div>

          <div className="signup-create-account">
            <span className="signup-login-cta">
              Already have an account?{" "}
              <a
                className="signup-login-cta-href"
                onClick={() => {
                  setShowLoginPopup(true);
                }}
              >
                Log in
              </a>
            </span>
          </div>
        </div>
      </div> */}

          <NarrowInputField
            name="Email Address"
            title="Email address"
            placeholder="Enter your email"
            isRequired
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            halfWidth={false}
          />

          <NarrowPasswordField
            title="Password"
            placeholder="Enter your password"
            isRequired
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <NarrowPasswordField
            title="Confirm Password"
            placeholder="Re-enter your password"
            isRequired
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <ul className="password-requirements">
            <li>Use at least 8 characters</li>
            <li>Use letters</li>
            <li>Use numbers</li>
            <li>Use special characters, like !#$%?</li>
          </ul>

          <button
            className="client-signup-continue-button"
            onClick={handleContinue}
            disabled={password.length < 8 || !passwordsMatch}
          >
            Continue
          </button>

          <div className="divider">
            <span>or</span>
          </div>
          <hr className="h-rule-popup" />

          <div className="signup-social-login-buttons">
            <button className="signup-google-btn">
              <FcGoogle style={{ paddingBottom: "1px" }} />
              Continue with Google
            </button>
            <button className="signup-apple-btn">
              <FaApple style={{ paddingBottom: "3px" }} />
              Continue with Apple
            </button>
          </div>

          <div className="signup-create-account">
            <span className="signup-login-cta">
              Already have an account?{" "}
              <a className="signup-login-cta-href" href="/">
                Log in
              </a>
            </span>
          </div>
        </div>
      </div>

      {showLoginPopup && (
        <ClientLoginPopup show={showLoginPopup} onClose={closeLoginPopup} />
      )}
      <Footer />
    </div>
  );
};

export default ClientSignupWithAppointment;
